export default {
      id: "telegram-usage",
      viewBox: "0 0 29 25",
      url: __webpack_public_path__ + "img/icons.f163a2c6.svg#telegram",
      toString: function () {
        return this.url;
      }
    }